import {
  keepPreviousData,
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarAreasAdmin,
  listarTodasLasAreas,
  type ListarAreasParams,
} from "../services/areas-service";

/**
 * Catálogo COMPLETO de áreas (sin paginar) · lo consumen usuarios y
 * niveles de autorización para asignar sobre todo el catálogo. Comparte
 * el prefijo `qk.adminAreas` con el listado paginado, así una mutación
 * invalida ambas variantes de un tiro.
 */
export const areasAdminQueryOptions = queryOptions({
  queryKey: [...qk.adminAreas, "todas"] as const,
  queryFn: listarTodasLasAreas,
});

export function useAreasAdmin() {
  return useSuspenseQuery(areasAdminQueryOptions);
}

/**
 * Listado PAGINADO (server-side) para la página /admin/areas · búsqueda +
 * página en el queryKey · `keepPreviousData` evita parpadeo al teclear.
 */
export const areasAdminPageQueryOptions = (params: ListarAreasParams = {}) =>
  queryOptions({
    queryKey: [...qk.adminAreas, params] as const,
    queryFn: () => listarAreasAdmin(params),
    placeholderData: keepPreviousData,
  });

export const useAreasAdminPage = (params: ListarAreasParams = {}) =>
  useQuery(areasAdminPageQueryOptions(params));
